// extracted by mini-css-extract-plugin
export default {"selection":"Selection_selection__zeO5Z","title":"Selection_title__nBGfw","item":"Selection_item__Ox-CL","selected":"Selection_selected__Vx-N0","links":"Selection_links__Ar7Nb"};